import { chatsOwner } from './chatsKeys';

/*
 * r16sd review MF2 (2026-10-27): every Settings Doctor query key carries the signed-in ACCOUNT. App.js keeps one QueryClient for the
 * whole tab and signing out / in is an SPA navigate, so a key without the account let account B see account A's credits, account
 * banners and slot panels (slot names like slot5 repeat across accounts) until the staleTime ran out - the r16p review T1 class of bug.
 *
 *   ['me', 'doctor', owner]          the /uiapi/me poll (hooks/useDoctorMe.js)
 *   ['doctor', owner, slotName]      GET /uiapi/slots/{slot}/doctor (components/doctor/DoctorDrawer.js usePanel, the Follow-back note,
 *                                    the settings page's refresh after a save or a fix)
 *
 * `owner` is lib/chatsKeys.js chatsOwner (u<id>, else the e-mail, else 'signed-out'): never logged, never in a URL. The roots stay
 * ['me', 'doctor'] and ['doctor'], so one invalidate / remove of a root reaches every account's entries
 * (components/doctor/DoctorCacheGuard.js drops them on sign-out and on any account change).
 */
export const doctorOwner = (user) => chatsOwner(user);

export const DOCTOR_ROOT = ['doctor'];
export const DOCTOR_ME_ROOT = ['me', 'doctor'];

export const doctorMeKey = (owner) => ['me', 'doctor', owner || 'signed-out'];
export const panelKey = (owner, slotName) => ['doctor', owner || 'signed-out', slotName];

/** Drops every account's doctor data from the cache (sign-out, another account signing in). */
export function dropDoctorCaches(queryClient) {
  queryClient.removeQueries({ queryKey: DOCTOR_ROOT });
  queryClient.removeQueries({ queryKey: DOCTOR_ME_ROOT });
}
